const commonKeys = {
    "location": "Location",
    "detectedAt": "Detected At",
    "identifiedOther": "Identified Other",
    "actionRequired": "Action Required",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "submittedAt": "Submitted At",
    "status": "Status",
    "sequenceNo": "Sequence Number",
    "l3Contractor": "L3 Contractor",
    "site": "Site",
    "project": "Project",
    "city": "City",
    "state": "State",
    "country": "Country",
    "businessUnit": "Business Unit",
    "actions": "Actions",
    "costs": "Costs",
    "files": "Files",
    "createdByUser": "Created By User",
    "updatedByUser": "Updated By User",
    "responsibleManager": "Responsible Manager",
    "closeoutManager": "Closeout Manager"
}
const uniqueKeys = {
    "hazardData": {
        "details": "Details",
        "immediateAction": "Immediate Action",
        "isImprovement": "Is Improvement",
        "factors": "Factors",
        "actualHazards": "Actual Hazards",
        "supervisor": "Supervisor"
    },
    "incidentReport": {
        "dhsIncident": "DHS Incident",
        "description": "Description",
        "wri": "WRI",
        "rni": "RNI",
        "ci": "CI",
        "ni": "NI",
        "secondaryHazards": "Secondary Hazards",
        "aCategory": "Actual Category",
        "pCategory": "Potential Category",
        "involved": "Involved",
        "witnesses": "Witnesses"
    },
    "nonConformity": {
        "ncAP": "NC AP",
        "summary": "Summary",
        "detail": "Detail",
        "contractors": "Contractors",
        "suppliers": "Suppliers",
        "logs": "Logs"
    },
    "improvementOpportunity": {
        "improvementcategory": "Improvement Category"
    },
    "complaints": {
        "significance": "Significance",
        "receiveType": "Receive Type",
        "issuedAt": "Issued At",
        "clientName": "Client Name",
        "complainantName": "Complainant Name",
        "address1": "Address 1",
        "address2": "Address 2",
        "suburb": "Suburb",
        "postalCode": "Postal Code",
        "contact1": "Contact 1",
        "contact2": "Contact 2",
        "source": "Source",
        "receivedByUser": "Received By User"
    }
}

export {commonKeys, uniqueKeys}